import { Injectable } from '@angular/core';
import posts from '../components/inside/posts_data.json'

@Injectable({
  providedIn: 'root'
})
export class SearchpostService {

  public postData: {index: string, category: string, title: string, creator: string, date: string, imagepath: string}[] = posts;
  filteredData = [];
  
  constructor() { }

  searchPost(s) : any {

    this.filteredData = this.postData.filter(datum =>
       (datum.category.indexOf(s) > -1 || datum.category.indexOf(s) > -1));
    
    return this.filteredData;

  }


}
